"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANCONTACT_BRAND_ID = exports.PayButtonLevel = void 0;
var PayButtonLevel;
(function (PayButtonLevel) {
    PayButtonLevel["balance"] = "balance";
    PayButtonLevel["transaction"] = "transaction";
    PayButtonLevel["balancePOP"] = "balancePOP";
})(PayButtonLevel = exports.PayButtonLevel || (exports.PayButtonLevel = {}));
exports.BANCONTACT_BRAND_ID = 'Bancontact/Mister Cash';
